export default {
	到: '到',
	登录: '登錄',
	第三方登录: '第三方登錄',
	点击登录: '點擊登錄',
	点击注册: '點擊註冊',
	记住我: '記住我',
	距离完成注册仅剩下最后一步: '距離完成註冊，僅剩下最後一步啦！！！',
	没有账号: '沒有帳號',
	设置密码: '設置密碼',
	完成注册: '完成註冊',
	'忘记密码?': '忘記密碼？',
	修改密码: '修改密碼',
	验证码: '驗證碼',
	已有账号: '已有帳號',
	重新发送: '重新發送',
	注册: '註冊',
	注册验证码: '註冊驗證碼',
	重置密码: '重置密碼',
	重置密码成功: '重置密碼成功',
	重置密码成功提示: '請保管好您的新密碼，並使用新密碼登錄',
}
